import React from "react";
import Navbar from "../components/LandingPageNew/Navbar";
import HeroSection from "../components/LocalListing/HeroSection";
import Attention from "../components/WebDesign/Attention";
import CustomerReviews from "../components/LandingPageNew/CustomerReviews";
import one from "../Images/new/1.jpg";
import two from "../Images/new/2.jpg";
import three from "../Images/new/3.jpg";
import four from "../Images/new/4.jpg";
import icon1 from "../Images/img/Component 16-18.png";
import icon2 from "../Images/img/Component 16-19.png";
import icon3 from "../Images/img/Component 16-20.png";
import icon4 from "../Images/img/Component 16-11.png";
import Footer from "../components/LandingPageNew/Footer";
import Hero from "../components/LocalListing/Hero";
import SEO from "../components/Shared/SEO";
const LocalListing = () => {
  const reviews = [
    {
      name: "Meagram",
      role: "",
      image: one,
      text: `"Als kleines Unternehmen fehlt uns die Zeit für Onlinepflege. uneva hat das perfekt übernommen – ein echter Gewinn für unsere Sichtbarkeit."`,
    },
    {
      name: "Mayks Intensivfahrschule",
      role: "",
      image: two,
      text: `"Wir sind endlich überall korrekt gelistet – von Google bis Yelp. Die Einträge wurden komplett für uns übernommen, und seitdem werden wir deutlich häufiger gefunden."`,
    },
    {
      name: "Hirsch ",
      role: "",
      image: three,
      text: `"Früher hatten wir überall unterschiedliche Öffnungszeiten – jetzt ist alles einheitlich. uneva hat alles für uns eingetragen. Super einfach und endlich professionell!"`,
    },
  ];
  const cardData = [
    {
      icon: icon1,
      step: "01",
      heading: "Bessere Sichtbarkeit",
      description:
        "Mit Local Listings steigerst du deine Sichtbarkeit: Einheitliche Firmeneinträge und hochwertige Backlinks stärken dein Ranking. Je mehr verlässliche Einträge, desto besser deine Position in lokalen Suchergebnissen bei Google und Bing.",
    },
    {
      icon: icon2,
      step: "02",
      heading: "ÜBER 60 Plattformen",
      description:
        "Mit UNEVA bleiben Ihre Firmendaten, Öffnungszeiten und Kontaktinfos auf über 60 Plattformen stets aktuell.Von Google bis Das Örtliche: UNEVA bringt dein Unternehmen auf alle relevanten Verzeichnisse – für maximale Online-Präsenz. ",
    },
    {
      icon: icon3,
      step: "03",
      heading: "DASHBOARD inkl. Bewertungsmanagement",
      description:
        "Behalte Einträge, Bewertungen und Plattform-Status jederzeit im Griff. Einfach, übersichtlich und zentral verwaltet – dein digitales Kontrollzentrum für maximale Sichtbarkeit.",
    },
    {
      icon: icon4,
      step: "04",
      heading: "Mehr Vertrauen bei Kunden",
      description:
        "Einheitliche und aktuelle Einträge wirken professionell – und stärken das Vertrauen neuer Kund:innen schon vor dem ersten Kontakt.",
    },
  ];
  return (
    <>
      <SEO
        title="Lokal besser gefunden werden | Mehr Kunden vor Ort"
        description="Professionelle Local-Listing-Optimierung für Google & Branchenverzeichnisse. 
Mehr lokale Sichtbarkeit, Vertrauen und Anfragen."
        canonical="https://uneva.de/local-listing-optimierung"
      />
      <div className="relative min-h-screen">
        {/* Navbar on top of hero */}
        <Navbar />
        <Hero />

        {/* <HeroSection /> */}
        <Attention title="" cards={cardData} />
        <CustomerReviews
          reviews={reviews}
          title="KUNDEN FEEDBACK"
          subtitle=""
        />
        <Footer />
      </div>
    </>
  );
};

export default LocalListing;
